var map = {
	"./SpinTorreB2_001.webp": 519,
	"./SpinTorreB2_002.webp": 1318,
	"./SpinTorreB2_003.webp": 2567,
	"./SpinTorreB2_004.webp": 8185,
	"./SpinTorreB2_005.webp": 5019,
	"./SpinTorreB2_006.webp": 1186,
	"./SpinTorreB2_007.webp": 3364,
	"./SpinTorreB2_008.webp": 8700,
	"./SpinTorreB2_009.webp": 7601,
	"./SpinTorreB2_010.webp": 574,
	"./SpinTorreB2_011.webp": 5229,
	"./SpinTorreB2_012.webp": 9222,
	"./SpinTorreB2_013.webp": 4170,
	"./SpinTorreB2_014.webp": 7641,
	"./SpinTorreB2_015.webp": 562,
	"./SpinTorreB2_016.webp": 7515,
	"./SpinTorreB2_017.webp": 9949,
	"./SpinTorreB2_018.webp": 2477,
	"./SpinTorreB2_019.webp": 8831,
	"./SpinTorreB2_020.webp": 8145,
	"./SpinTorreB2_021.webp": 6257,
	"./SpinTorreB2_022.webp": 9226,
	"./SpinTorreB2_023.webp": 9401,
	"./SpinTorreB2_024.webp": 3532,
	"./SpinTorreB2_025.webp": 4107,
	"./SpinTorreB2_026.webp": 6783,
	"./SpinTorreB2_027.webp": 4902,
	"./SpinTorreB2_028.webp": 121,
	"./SpinTorreB2_029.webp": 2394,
	"./SpinTorreB2_030.webp": 345,
	"./SpinTorreB2_031.webp": 5415,
	"./SpinTorreB2_032.webp": 2681,
	"./SpinTorreB2_033.webp": 281,
	"./SpinTorreB2_034.webp": 9922,
	"./SpinTorreB2_035.webp": 5115,
	"./SpinTorreB2_036.webp": 3282,
	"./SpinTorreB2_037.webp": 2396,
	"./SpinTorreB2_038.webp": 994,
	"./SpinTorreB2_039.webp": 7661,
	"./SpinTorreB2_040.webp": 6553,
	"./SpinTorreB2_041.webp": 3010,
	"./SpinTorreB2_042.webp": 1929,
	"./SpinTorreB2_043.webp": 7105,
	"./SpinTorreB2_044.webp": 899,
	"./SpinTorreB2_045.webp": 3894,
	"./SpinTorreB2_046.webp": 5234,
	"./SpinTorreB2_047.webp": 8170,
	"./SpinTorreB2_048.webp": 9550,
	"./SpinTorreB2_049.webp": 1831,
	"./SpinTorreB2_050.webp": 8265,
	"./SpinTorreB2_051.webp": 2455,
	"./SpinTorreB2_052.webp": 7996,
	"./SpinTorreB2_053.webp": 7013,
	"./SpinTorreB2_054.webp": 8227,
	"./SpinTorreB2_055.webp": 4665,
	"./SpinTorreB2_056.webp": 3024,
	"./SpinTorreB2_057.webp": 1711,
	"./SpinTorreB2_058.webp": 9602,
	"./SpinTorreB2_059.webp": 2427,
	"./SpinTorreB2_060.webp": 9537,
	"./SpinTorreB2_061.webp": 9164,
	"./SpinTorreB2_062.webp": 9426,
	"./SpinTorreB2_063.webp": 9596,
	"./SpinTorreB2_064.webp": 5823,
	"./SpinTorreB2_065.webp": 1111,
	"./SpinTorreB2_066.webp": 8198,
	"./SpinTorreB2_067.webp": 9917,
	"./SpinTorreB2_068.webp": 556,
	"./SpinTorreB2_069.webp": 6016,
	"./SpinTorreB2_070.webp": 3812,
	"./SpinTorreB2_071.webp": 3285,
	"./SpinTorreB2_072.webp": 4619
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8748;